import React from "react";
import "./Popup.css";
import close from "../../images/close-btn.svg";

const FormPopup = ({ isFormSend, fn, message, fnTwo }) => {
  return (
    isFormSend && (
      <div className="lottolegenda-popup lottolegenda-form-popup">
        <div className="lottolegenda-form-popup__body">
          <p className="t-21 text-center col-blue fw-700">
            You are registered!
          </p>
          <img
            src={close}
            title="close btn"
            alt="close btn"
            className="lottolegenda-form-popup__close"
            onClick={() => {
              fnTwo(false);
              fn(false);
            }}
          />
        </div>
      </div>
    )
  );
};

export default FormPopup;
